<template lang="pug">
div
	.alert.alert-info
		|Aquí puedes configurar las direcciones de correo electrónico <b>corporativos</b> de este usuario.
		|Puedes añadir tantas direcciones como consideres oportuno. Pero ten en cuenta que también <b>puedes hacer uso de
		|los alias</b> para "simular" varias direcciones de correo.
	b E-mails
	.mt-2(v-for="(email, index) in emails" :key="'email_' + index")
		.input-group.input-group-sm
			input.form-control(type="email" placeholder="usuario" v-model="email.cuenta")
			.input-group-append
				span.input-group-text
					|@
			select.form-control(v-model="email.dominio_id")
				option(:value="dominio.id" v-for="dominio in dominios" :key="dominio.id") {{dominio.dominio}}
			.input-group-append
				span.input-group-text
					|Cuota
			input.form-control(type="number" style="max-width:60px !important;" v-model="email.cuota" placeholder="XX")
			.input-group-append
				span.input-group-text
					|Gb
			.input-group-append(@click="emails.splice(index, 1)")
				button.btn.btn-sm.btn-danger
					span.fa.fa-trash
	.text-center.alert.alert-danger.mt-2(v-if="emails.length === 0")
		span.fa.fa-ban(style="font-size:2em;")
		br
		h5 <b>Este usuario no tiene direcciones de e-mail</b>
	.row.mt-2
		.col.text-left
			button.btn.btn-sm.btn-primary.mt-2.mb-2(@click="nuevoEmail()")
				span.fa.fa-plus.mr-2
				|Añadir
		.col.text-right
			button.btn.btn-sm.btn-success.mt-2.mb-2(@click="guardar()")
				span.fa.fa-save.mr-2
				|Guardar
	hr
	b Alias
	.alert.alert-warning.mt-2
		|Desde aquí tan solo puedes ver los alias en los que están incluídas las direcciones de este usuario. Para editarlos debes irte a la herramienta de gestión
		|de cuentas de correo en el panel de control.
	.mt-2(v-for="alias in aliases" :key="alias.origen")
		.input-group.input-group-sm
			input.form-control(type="email" placeholder="" readonly :value="alias.origen")
			.input-group-append
				span.input-group-text.fa.fa-arrow-right
			input.form-control(type="email" placeholder="" readonly :value="alias.destino")
</template>
<script>
import API from '../api'
export default {
	props: ['usuario'],
	data () {
		return {
			emails: [],
			aliases: [],
			dominios: []
		}
	},

	created () {
		API.getDominios()
			.then(res => {
				this.dominios = res.data.dominios
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
		// Vamos a obtener las direcciones de e-mail de este usuario
		API.getEmails(this.usuario.ID)
			.then(res => {
				this.emails = res.data.emails
				this.aliases = res.data.alias
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},

	methods: {
		guardar () {
			API.setEmails(this.usuario.ID, this.emails)
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Correcto',
						mensaje: 'Se han guardado los cambios correctamente'
					})
					this.emails = res.data.emails
					this.alias = res.data.alias
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		nuevoEmail () {
			this.emails.push({
				cuenta: '',
				cuenta_id: null,
				dominio_id: 1,
				dominio: '',
				cuota: 10
			})
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/gestion-usuarios/vue/editor/emails.vue